export default "__VITE_ASSET__BRlHtZl5__"